
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Sponsors extends Vue {
  @Prop() title!: string;
  @Prop() logos!: {
    src: string;
    alt: string;
    href: string;
    class: string;
  }[];
}
